<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="content-section section-reservations">
			<div class="row">
				<div class="columns column6">
					<h3>{{ defaults[locale].website.restaurantName }}</h3>
					<div class="address">
						<p>
							<span> {{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
							<br />
							<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
							<br />
							<span>{{ defaults[locale].website.country }}</span>
							<br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>{{ defaults[locale].website.phone }}</span>
							</a>
							<br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>{{ defaults[locale].website.email }}</span>
							</a>
						</p>
					</div>
				</div>
				<div class="columns column6">
					<div class="form-wrapper">
						<contact-form name="contact" :form="form" />
					</div>
				</div>
			</div>
		</section>

		<section class="maps-section">
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2448.7049278015315!2d6.194581199999999!3d52.139688799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c7946bf077f4d1%3A0xdf6b764ebcf992c3!2sBrasserie%206!5e0!3m2!1snl!2snl!4v1740396578928!5m2!1snl!2snl"
				width="100%"
				height="550"
				style="border: 0"
				allowfullscreen
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
			/>
		</section>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
}

.section-reservations {
	padding-top: 0;
}

.form-wrapper {
	padding: 40px 30px;
	background: var(--secondary-background-color);
}
</style>
